
// 运单明细
export const waybillConfig = {
    table: {
        columns: [
            {
                label: 'TK单号',
                prop: 'taskNo',
                width: 180
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: 150
            },
            {
                label: '商品总数量',
                prop: 'totalQty'
            },
            {
                label: '总重量(kg)',
                prop: 'totalGrossWeight'
            },
            {
                label: '总方量(m³)',
                prop: 'totalVolume'
            },
            {
                label: '服务平台',
                prop: 'siteName'
            },
            {
                label: '客户',
                prop: 'customerName'
            },
            {
                label: '收货单位',
                prop: 'upperReceiverName'
            },
            {
                label: '收货市名称',
                prop: 'receiverCityName'
            },
            {
                label: '收货区名称',
                prop: 'receiverDistrictName'
            },
            {
                label: '收货乡镇名称',
                prop: 'receiverTownName'
            },
            {
                label: '收货详细地址',
                prop: 'receiverDetailAddr'
            },
            {
                label: '收货人',
                prop: 'receiverName'
            },
            {
                label: '收货人联系方式',
                prop: 'receiverMobile'
            }
        ]
    }
};

// 发车单明细
export const departDetailsConfig = {
    table: {
        columns: [
            {
                label: 'TK单号',
                prop: 'taskNo',
                width: 180
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: 150
            },
            {
                label: "包装数",
                prop: "totalPackageQuantity"
            },
            {
                label: '收货人',
                prop: 'receiverName',
                width: 80
            },
            {
                label: '收货详细地址',
                prop: 'receiverDetailAddr'
            },
            {
                label: '货值',
                prop: 'orderValue'
            },
            {
                label: '装货仓库',
                prop: 'whName'
            },
            {
                label: '收货人联系方式',
                prop: 'receiverTel'
            },
            {
                label: '重量(kg)',
                prop: 'totalGrossWeight',
                width: 80
            },
            {
                label: '体积(m³)',
                prop: 'totalVolume',
                width: 80
            },
            {
                label: '商品数量',
                prop: 'totalQty',
                width: 80
            },
            {
                label: '商品类型',
                prop: 'itemClassName'
            },
            {
                label: '专业公司',
                prop: 'professionalCompanyName'
            },
            {
                label: '收货单位',
                prop: 'upperReceiverName'
            },           
        ]
    }
};
